<div id="overlay">
  <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
  <div class="pop-up-container">
    <div id="dummy-overlay-1" (click)="onCloseClick($event)"></div>
    <img
      class="popupimg"
      src="assets/images/common/popup_bg_small.webp?t={{ version }}"
    />
    <img
      class="closeiconImg"
      [appImageSprite]="'close'"
      [params]="menu_icons"
      (click)="onCloseClick($event)"
    />

    <h3 class="lang-specific-popup-header lang-specific-font-name">
      <img
        [ngClass]="[isMac + 'lang-specific-iconImg']"
        class="lang-specific-iconImg"
        [appImageSprite]="'settings_icon'"
        [params]="menu_icons"
      />
      {{ 'LANG00147' | translate }}
    </h3>

    <h3 class="lang-specific-popup-cntnt lang-specific-font-name">
      {{ 'LANG00148' | translate }}
    </h3>

    <img
      class="arrImg"
      [appImageSprite]="'down_arrow1'"
      [params]="common_icons"
    />

    <img
      class="imgFlag"
      [appImageSprite]="data.currentLanguage + '_flag'"
      [params]="lang_icons"
    />

    <h4 class="lang-specific-txtCont lang-specific-font-name">
      {{ 'LANG00137' | translate }}
    </h4>

    <img
      (click)="buttonClick($event)"
      (mouseover)="buttonOverOrOut(isView)"
      (mouseout)="buttonOverOrOut(isView)"
      *ngIf="isView"
      class="lang-specific-radio"
      [ngClass]="[isMac + 'lang-specific-radio']"
      [appImageSprite]="'option_unselect'"
      [params]="menu_icons"
    />

    <img
      (click)="buttonClick($event)"
      (mouseover)="buttonOverOrOut(isView)"
      (mouseout)="buttonOverOrOut(isView)"
      *ngIf="!isView"
      class="lang-specific-radio"
      [ngClass]="[isMac + 'lang-specific-radio']"
      [appImageSprite]="'option_select'"
      [params]="menu_icons"
    />

    <h4
      [ngClass]="[isMac + 'lang-specific-tipsCont']"
      class="lang-specific-tipsCont lang-specific-font-name"
    >
      {{ 'LANG00149' | translate }}
    </h4>

    <img
      class="arrAbout"
      [appImageSprite]="'down_arrow1'"
      [params]="common_icons"
    />

    <h4 class="lang-specific-aboutUs lang-specific-font-name">
      {{ 'LANG00150' | translate }}
    </h4>
    <div class="lang-container"></div>
    <div
      class="tips-container"
      (mouseover)="buttonOverOrOut(isView)"
      (mouseout)="buttonOverOrOut(isView)"
    ></div>
    <div class="aboutUs-container" (click)="onAboutUsClick($event)"></div>
  </div>
</div>
